<template>
  <v-card class="mb-4" color="rgb(250, 250, 250)">
    <v-toolbar dense :color="color" dark flat>
      <v-icon class="mr-3">{{ icono }}</v-icon>
      <v-toolbar-title>{{ titulo }}</v-toolbar-title>
      <v-spacer />
      <v-chip small color="amber darken-2" text-color="blue-grey darken-4" class="mr-2 font-weight-bold">
        <v-icon left small>mdi-star</v-icon>
        {{ formatearValoracion(resumen.valoracion) }}
      </v-chip>
      <v-chip small light class="mr-2">
        {{ resumen.total_valoraciones }} valoraciones
      </v-chip>
      <v-chip small light>
        {{ resumen.total_respuestas }} respuestas
      </v-chip>
    </v-toolbar>

    <v-card-text>
      <v-alert v-if="!resumen.total_respuestas" type="info" outlined class="mb-0">
        No hay valoraciones en esta sección.
      </v-alert>

      <v-expansion-panels v-else-if="agruparPorProveedor" v-model="proveedoresAbiertos" multiple accordion>
        <v-expansion-panel v-for="grupo in proveedores" :key="grupo.proveedor.id">
          <v-expansion-panel-header>
            <div class="d-flex align-center pr-4 proveedor-header">
              <div>
                <div class="font-weight-bold">{{ nombreProveedor(grupo.proveedor) }}</div>
                <div class="text-caption text--secondary">
                  {{ grupo.resumen.total_valoraciones }} valoraciones ·
                  {{ grupo.resumen.total_respuestas }} respuestas
                </div>
              </div>
              <v-spacer />
              <v-chip small color="amber lighten-4" text-color="amber darken-4" class="font-weight-bold">
                <v-icon left small color="amber darken-2">mdi-star</v-icon>
                {{ formatearValoracion(grupo.resumen.valoracion) }}
              </v-chip>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <valoraciones-preguntas :preguntas="grupo.resumen.preguntas" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <valoraciones-preguntas v-else :preguntas="preguntas" />
    </v-card-text>
  </v-card>
</template>

<script>
import ValoracionesPreguntas from "@/components/valoraciones/ValoracionesPreguntas.vue";
import {
  agruparResumenPorProveedor,
  nombreProveedor,
} from "@/helpers/valoracionesHelpers";

export default {
  name: "ValoracionesSeccion",

  data: () => ({
    proveedoresAbiertos: [],
  }),

  components: {
    ValoracionesPreguntas,
  },

  props: {
    titulo: {
      type: String,
      required: true,
    },
    icono: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    resumen: {
      type: Object,
      required: true,
    },
    agruparPorProveedor: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    preguntas() {
      return Array.isArray(this.resumen.preguntas) ? this.resumen.preguntas : [];
    },

    proveedores() {
      return this.agruparPorProveedor ? agruparResumenPorProveedor(this.resumen) : [];
    },
  },

  watch: {
    proveedores: {
      immediate: true,
      handler(proveedores) {
        this.proveedoresAbiertos = proveedores.map((proveedor, index) => index);
      },
    },
  },

  methods: {
    nombreProveedor,

    formatearValoracion(valoracion) {
      if (valoracion === null || valoracion === undefined) return "Sin valorar";
      return `${Number(valoracion).toFixed(1).replace(".", ",")} / 10`;
    },
  },
};
</script>

<style scoped>
.proveedor-header {
  width: 100%;
}
</style>
